import { GDRIVE } from './attachmentConstants';
import getGDriveItemThumbnailUrl from './getGDriveItemThumbnailUrl';
import { getAttachmentUrl } from 'owa-attachment-url';
import { ClientAttachmentId } from 'owa-client-ids';
import AttachmentUrlType from 'owa-files-url/lib/schema/AttachmentUrlType';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import ReferenceAttachment from 'owa-service/lib/contract/ReferenceAttachment';

export default async function getAttachmentThumbnailUrl(
    attachmentId: ClientAttachmentId,
    attachment: AttachmentType,
    isCloudy: boolean
): Promise<string | null> {
    if (!isCloudy) {
        return getAttachmentUrl(
            attachmentId,
            attachment,
            AttachmentUrlType.Thumbnail,
            isCloudy,
            true
        );
    }

    const referenceAttachment = attachment as ReferenceAttachment;
    if (referenceAttachment.ProviderType === GDRIVE && referenceAttachment.AttachLongPathName) {
        // In case of google drive we need to make a call to an API to get the thumbnail url
        return await getGDriveItemThumbnailUrl(referenceAttachment);
    }

    return referenceAttachment.AttachmentThumbnailUrl || null;
}
